import { Card as CardComponent } from "@heroui/react";

type CardProps = React.ComponentProps<typeof CardComponent>;

export const Card = ({ children, ...props }: CardProps) => {
    return (
        <CardComponent shadow="sm" radius="md" {...props} className="flex-1 bg-background/95 dark:bg-background/90 backdrop-blur-md border-2 border-primary/40 dark:border-primary/60 hover:border-primary/60 dark:hover:border-primary/80 transition-all duration-200 hover:shadow-lg hover:shadow-primary/20">
            {children}
        </CardComponent>
    );
};